import adapter from '../adapter-portfolio-projects';
var IDs = adapter.IDs;
export default {
    type: adapter.SchemaTypes.PROJECT_IMAGES,
    schema: {
        '@context': 'https://schema.org',
        images: "{{".concat(IDs.SD_JSON_IMAGES, "}}"),
    },
};
